import * as React from 'react';
import StaticImageForm from "../../components/StaticImages/StaticImageForm/StaticImageForm";
var StaticImage = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u0441\u0442\u0430\u0442\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5 offset-md-4" },
                    React.createElement(StaticImageForm, null))))));
};
export default StaticImage;



//////////////////
// WEBPACK FOOTER
// ./src/views/StaticImages/StaticImage.tsx
// module id = 473
// module chunks = 0